module.exports = __webpack_public_path__ + "img/el.760ef511.svg";